import React, { useEffect, useRef, useState } from "react";
import Header from "../layout/Header";
import "react-dropzone-uploader/dist/styles.css";
import Swal from "sweetalert2";
import { useLocation, useNavigate, useParams } from "react-router";
import { useDispatch } from "react-redux";
import { connect } from "react-redux";
import { attachFile, resetAttachFile } from "../../actions/v3/attachFile"; // Yolunuz projenize göre değişiklik gösterebilir
import { applicationDetail } from "../../actions/v3/applicationDetail";
import { dettachFile } from "../../actions/v3/dettachFile";

function FileUpload(props) {
  const { Id } = useParams();
  const navigate = useNavigate();
  const fileInputRef = useRef(null); // Ref for file input
  const dispatch = useDispatch();
  const [file, setFile] = useState(null);
  const applicationId = Id;
  const location = useLocation();

  const [attachment, setAttachment] = useState(null);
  const searchParams = new URLSearchParams(location.search);
  const facility = searchParams.get("facility");

  console.log(facility);
  
  useEffect(() => {
    dispatch(applicationDetail(Id));
  }, [dispatch]);

  useEffect(() => {
    if (props.applicationDetail.done) {
      setAttachment(
        props.applicationDetail.applicationDetail.result.attachments
      );
    }
  }, [props.applicationDetail]);

  useEffect(() => {
    if (props.attachFile.done) {
      dispatch(applicationDetail(Id));
      setFile(null); // Clear the file state
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Reset the file input
      }
      resetAttachFile();
    }

    if (props.attachFile.error !== false) {
      Swal.fire({
        title: "Hata!",
        text: "Dosya yüklenirken bir hata oluştu",
        icon: "error",
        confirmButtonText: "Tamam"
      });
      setFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Reset the file input
      }
      resetAttachFile();
    }
  }, [props.attachFile, dispatch]);

  useEffect(() => {
    if (props.dettachFile.done) {
      dispatch(applicationDetail(Id));
    }
  }, [props.dettachFile]);

  function handleSubmit() {
    if (
      props.applicationDetail?.applicationDetail?.result?.applicationStatus !==
      0
    ) {
      navigate(`/applications`);
      return;
    }
    if (!props.attachFile.spinner) {
      navigate(
        `/paymentv2/${applicationId}?facility=${
          facility === "0" ? "başkent" : "erciyes"
        }`
      );
      return;
    }
  }

  console.log(props.applicationDetail);

  return (
    <div>
      <Header />

      <div className="pt-10 md:ml-64 ps-5">
        <ol
          className="flex items-center whitespace-nowrap min-w-0"
          aria-label="Breadcrumb"
        >
          <li className="text-sm">
            <span
              className="flex items-center text-gray-500 "
            >
              Yeni Başvuru
              <svg
                className="flex-shrink-0 mx-3 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </span>
          </li>
          <li className="text-sm">
            <span
              className="flex items-center text-gray-500 "
            >
              Talep Formu
              <svg
                className="flex-shrink-0 mx-3 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </span>
          </li>
          <li
            className="text-sm font-semibold text-gray-800 truncate dark:text-gray-200"
            aria-current="page"
          >
            Dosya Yükleme
          </li>
        </ol>
      </div>
      <hr className="divide-y mt-2" />
      <h1 className="text-2xl font-semibold text-start mt-5 ps-5 md:ml-64">
        Hastalığınızla İlgili Dosyalar
      </h1>
      <div className="mt-5 ps-5 pe-5 md:ml-64">
        <label
          htmlFor="hs-select-label"
          className="block text-sm font-medium mb-2 dark:text-white text-start"
        >
          Dosya Kategorisini Seçin
        </label>
        <select
          onChange={(e) => {
            // setFileModel(e.target.value)
          }}
          // value={fileModel}
          id="hs-select-label"
          className="py-3 px-4 pr-9  w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
        >
          <option selected>Lütfen Seçiniz</option>
          <option value="Ameliyat Dosyası">Ameliyat Dosyası</option>
          <option value="Epikriz Dosyası">Epikriz Dosyası</option>
          <option value="Patoloji Dosyası">Patoloji Dosyası</option>
          <option value="CT (Bilgisayarlı Tomografi) Dosyası">
            CT (Bilgisayarlı Tomografi) Dosyası
          </option>
          <option value="MR (Manyetik Rezonans) Dosyası">
            MR (Manyetik Rezonans) Dosyası
          </option>
          <option value="PET (Pozitron Emisyon Tomografi) Dosyası">
            PET (Pozitron Emisyon Tomografi) Dosyası
          </option>
          <option value="USG (Röntgen) Dosyası">USG (Röntgen) Dosyası</option>
          <option value="Mamografi Dosyası">Mamografi Dosyası</option>
          <option value="Laboratuvar Dosyası">Laboratuvar Dosyası</option>
          <option value="Diğer">Diğer</option>
        </select>
      </div>
      <div className="mt-5 ps-5 pe-5 md:ml-64">
        <div className="flex justify-between w-full">
          <div className="border border-gray-300 p-1 mb-10 shadow-md">
            <div className="flex items-center px-2 space-x-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M17.5 19.25h-11a2.75 2.75 0 0 1-2.75-2.75v-9A2.75 2.75 0 0 1 6.5 4.75H9a.77.77 0 0 1 .57.25l2.77 3.24h5.16A2.75 2.75 0 0 1 20.25 11v5.5a2.75 2.75 0 0 1-2.75 2.75Zm-11-13A1.25 1.25 0 0 0 5.25 7.5v9a1.25 1.25 0 0 0 1.25 1.25h11a1.25 1.25 0 0 0 1.25-1.25V11a1.25 1.25 0 0 0-1.25-1.25H12a.77.77 0 0 1-.57-.26L8.66 6.25Z"
                />
              </svg>
              <h4 className="font-semibold">Dosya Yükle</h4>
            </div>
            <label className="block p-4">
              <input
                ref={fileInputRef}
                onChange={(e) => {
                  if (!props.attachFile.spinner) {
                    // Only allow file selection if no upload is in progress
                    dispatch(attachFile(e.target.files[0], applicationId));
                  }
                }}
                disabled={props.attachFile.spinner} // Disable the input while uploading
                type="file"
                className="block w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold shadow-md"
              />
              <div>
                <div>
                  <small className="text-gray-600">
                    Sadece{" "}
                    <span className="font-semibold text-red-500">dicom</span>,{" "}
                    <span>dosyalarınız</span>{" "}
                    <span className="font-semibold text-red-500">.zip</span>{" "}
                    formatında yükleyiniz.
                  </small>
                </div>
                <div>
                  <small className="text-gray-600">
                    Dosya türü olarak{" "}
                    <span className="font-semibold text-red-500">PDF</span>,{" "}
                    <span className="font-semibold text-red-500">resim</span>{" "}
                    veya{" "}
                    <span className="font-semibold text-red-500">.zip</span>{" "}
                    tercih etmelisiniz.
                  </small>
                </div>
              </div>
            </label>
          </div>
          {/* <Dropzone
                        // onChangeStatus={handleChangeStatus}
                        // onSubmit={handleSubmit}
                        accept="image/*,audio/*,video/*" // Kabul edilen dosya türlerini burada belirleyebilirsiniz
                        inputContent="Dosyaları sürükleyip bırakın veya seçmek için tıklayın"
                        styles={{
                            dropzone: { minHeight: 200, maxHeight: 250 },
                            dropzoneActive: { borderColor: 'green' },
                        }}
                    /> */}
        </div>
        {props.attachFile.spinner ? (
          <div className="flex flex-col gap-y-2">
            <div className="flex items-center gap-x-3 whitespace-nowrap">
              <div
                className="flex w-full h-2 bg-gray-200 rounded-full overflow-hidden dark:bg-gray-700"
                role="progressbar"
                aria-valuenow={props.attachFile?.uploadProgress}
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div
                  className={`flex flex-col justify-center rounded-full overflow-hidden ${
                    props.attachFile?.uploadProgress === 100
                      ? "bg-green-600"
                      : "bg-blue-600"
                  } text-xs text-white text-center whitespace-nowrap transition duration-500`}
                  style={{ width: `${props.attachFile?.uploadProgress}%` }}
                ></div>
              </div>
              <div className="w-6 text-end">
                <span className="text-sm text-gray-800 dark:text-white">
                  {props.attachFile?.uploadProgress}%
                </span>
              </div>
            </div>
            {props.attachFile?.uploadProgress === 100 && (
              <div className="flex items-center gap-x-2 text-sm text-gray-600 dark:text-gray-400">
                <span className="animate-spin inline-block w-4 h-4 border-2 border-current border-t-transparent rounded-full"></span>
                <span>Dosya işleniyor, lütfen bekleyin...</span>
              </div>
            )}
          </div>
        ) : null}

        {props.applicationDetail?.applicationDetail?.result.attachments
          .length !== 0
          ? props.applicationDetail?.applicationDetail?.result.attachments.map(
              (element, index) => {
                return (
                  <>
                    <div>
                      <div className="mb-2 flex justify-between items-center">
                        <div className="flex items-center gap-x-3">
                          <span className="w-8 h-8 flex justify-center items-center border border-gray-200 text-gray-500 rounded-lg dark:border-neutral-700">
                            <img src={element.uploadUrl} width={30} alt="" />
                          </span>
                          <div>
                            <a href={element.viewUrl} target="_blank">
                              <p className="text-sm font-medium text-gray-800 dark:text-white">
                                {element.fileName}
                              </p>
                            </a>
                          </div>
                        </div>
                        <div
                          className={`inline-flex items-center gap-x-2 ${
                            props.applicationDetail?.applicationDetail?.result
                              ?.applicationStatus === 0
                              ? `Ödeme bekleniyor`
                              : props.applicationDetail?.applicationDetail
                                  ?.result?.applicationStatus === 11
                              ? `Tıbbi sekreterya`
                              : props.applicationDetail?.applicationDetail
                                  ?.result?.applicationStatus === 10
                              ? `hidden`
                              : props.applicationDetail?.applicationDetail
                                  ?.result?.applicationStatus === 3
                              ? `hidden`
                              : props.applicationDetail?.applicationDetail
                                  ?.result?.applicationStatus === 2 ||
                                props.applicationDetail?.applicationDetail
                                  ?.result?.applicationStatus === 4
                              ? `hidden`
                              : props.applicationDetail?.applicationDetail
                                  ?.result?.applicationStatus === 6
                              ? `hidden`
                              : null
                          }`}
                        >
                          <a
                            onClick={(e) => {
                              e.preventDefault();
                              dispatch(dettachFile(element.id, applicationId));
                            }}
                            className="text-gray-500 hover:text-gray-800"
                            href="#"
                          >
                            <svg
                              className="flex-shrink-0 w-4 h-4"
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M3 6h18" />
                              <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                              <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                              <line x1="10" x2="10" y1="11" y2="17" />
                              <line x1="14" x2="14" y1="11" y2="17" />
                            </svg>
                          </a>
                        </div>
                      </div>
                      <div className="flex items-center gap-x-3 whitespace-nowrap">
                        <div
                          className="flex w-full h-2 bg-gray-200 rounded-full overflow-hidden dark:bg-gray-700"
                          role="progressbar"
                          aria-valuenow="1"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          <div
                            className="flex flex-col justify-center rounded-full overflow-hidden bg-blue-600 text-xs text-white text-center whitespace-nowrap transition duration-500 dark:bg-blue-500"
                            style={{ width: `100%` }}
                          ></div>
                        </div>
                        <div className="w-6 text-end">
                          <span className="text-sm text-gray-800 dark:text-white">
                            100%
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                );
              }
            )
          : null}
        {props.applicationDetail.spinner ? (
          <div className="relative">
            <div
              style={{ backgroundColor: `#09c35d7c` }}
              className="bg-blue-50 border border-blue-200 rounded-md p-4"
            >
              <div className="flex">
                <div className="flex-shrink-0">
                  <i className="fa-light fa-file-import"></i>
                </div>
                <div className="ml-3">
                  <h3 className="text-sm text-blue-800 font-medium">
                    Dosyalar yükleniyor
                  </h3>
                  <div className="text-sm text-blue-700 mt-2">
                    <span className="font-semibold">Lütfen bekleyin!</span>{" "}
                    Dosyaların yüklenmesi devam ediyor.
                  </div>
                </div>
              </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full bg-white/[.5] rounded-md dark:bg-gray-800/[.4]"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <div
                className="animate-spin inline-block w-6 h-6 border-[3px] border-current border-t-transparent text-blue-600 rounded-full"
                role="status"
                aria-label="loading"
              >
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <div className="md:ml-64 ps-5 mt-5 pe-5">
        {props.attachFile.spinner === true ? (
          <button
            disabled
            type="button"
            className="mb-10 w-full py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-gray-500 text-white hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800 mt-5"
          >
            Devam et
          </button>
        ) : (
          <button
            onClick={handleSubmit}
            style={{ backgroundColor: `#09C35C` }}
            type="button"
            className="mb-10 w-full py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800 mt-5"
          >
            Devam et
          </button>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return state;
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(FileUpload);
